"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.eClaimProvider = exports.eFindClaimsFilterType = exports.eClaimStatus = exports.eCauseOfLoss = void 0;
const insuranceClaim_class_1 = __importDefault(require("./insuranceClaim.class"));
var eCauseOfLoss;
(function (eCauseOfLoss) {
    eCauseOfLoss["DAMAGE"] = "damage";
    eCauseOfLoss["THEFT"] = "theft";
    eCauseOfLoss["SHORTAGE"] = "shortage";
    eCauseOfLoss["TEMPERATURE_RELATED_ISSUE"] = "temperatureRelatedIssue";
    eCauseOfLoss["CONCEALED_DAMAGE"] = "concealedDamage";
    eCauseOfLoss["NON_DELIVERY"] = "nonDelivery";
    eCauseOfLoss["MISCELLANEOUS"] = "misc";
})(eCauseOfLoss = exports.eCauseOfLoss || (exports.eCauseOfLoss = {}));
var eClaimStatus;
(function (eClaimStatus) {
    eClaimStatus["DRAFT"] = "draft";
    eClaimStatus["SUBMITTED"] = "submitted";
    eClaimStatus["RESOLVED"] = "resolved";
    eClaimStatus["PROGRESSING"] = "progressing";
    eClaimStatus["PAID"] = "paid";
    eClaimStatus["REJECTED"] = "rejected";
    eClaimStatus["WITHDRAWN"] = "withdrawn";
    eClaimStatus["KYC_ERROR"] = "KYC Error";
    eClaimStatus["PAYMENT_OFFER_MADE"] = "Payment Offer Made";
    eClaimStatus["PAYMENT_OFFER_ACCEPTED"] = "Payment Offer Accepted";
    eClaimStatus["PENDING"] = "pending";
})(eClaimStatus = exports.eClaimStatus || (exports.eClaimStatus = {}));
var eFindClaimsFilterType;
(function (eFindClaimsFilterType) {
    eFindClaimsFilterType["PARTNER"] = "partner.id";
    eFindClaimsFilterType["OWNER"] = "assured.email";
    eFindClaimsFilterType["STATE"] = "claimStatus";
})(eFindClaimsFilterType = exports.eFindClaimsFilterType || (exports.eFindClaimsFilterType = {}));
var eClaimProvider;
(function (eClaimProvider) {
    eClaimProvider["VITESSE"] = "Vitesse";
    eClaimProvider["RAPHAEL_ASSOCIATES"] = "Raphael & Associates";
    eClaimProvider["WEBSTER"] = "Webster";
})(eClaimProvider = exports.eClaimProvider || (exports.eClaimProvider = {}));
exports.default = insuranceClaim_class_1.default;
//# sourceMappingURL=index.js.map